import ConfirmModal from '@components/modal/ConfirmModal';
import { useHistory } from 'react-router-dom';
import { ContactUsMessage } from 'src/types/shared/ContactUsMessages';
import useDeleteContactUsMessage from './hooks/useDeleteContactUsMessage';

const DeleteUserModal: React.FC<DeleteUserProps> = ({ message }) => {
    const history = useHistory();
    const { handleSubmit, isDeleting, deleteError } = useDeleteContactUsMessage(message.id);

    return (
        <ConfirmModal
            title="Delete message"
            description={`Are you sure you want to delete this message from '${message.firstName} ${message.lastName}'?`}
            closeModal={() => history.replace(`/contact-us-messages/${message.id}`)}
            handleSubmit={handleSubmit}
            isPosting={isDeleting}
            error={deleteError}
        />
    );
};

interface DeleteUserProps {
    message: ContactUsMessage;
}
export default DeleteUserModal;
